import { useState } from 'react'
import classes from './TextInputArea.module.css'

const TextInputArea = ({
  children,
  required,
  height,
  change,
  disabled,
  labelClasses,
  value,
  error,
  ...rest
}) => {
  const [focusClass, SetfocusClass] = useState('')

  const handleFocus = e => {
    SetfocusClass(classes.is_active)
  }

  const handleBlur = e => {
    SetfocusClass('')
  }

  return (
    <>
      <label
        className={`${
          classes.label
        } relative block border-1 border-solid border-white px-7 pt-9 mx-1.5 my-2 md:mx-3.5 md:my-5 flex-grow font-[sans-serif] ${labelClasses} ${
          error ? 'border-red' : ''
        }`}
      >
        <span
          className={`absolute text-darkGray top-4 left-7 text-base transition-transform ${focusClass} ${
            value.length > 0 ? 'hidden' : ''
          }`}
        >
          {children}
          {required && ' *'}
        </span>
        <textarea
          onChange={change}
          disabled={disabled}
          required={required}
          value={value}
          {...rest}
          style={{ height: height }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={` ${classes.textarea} bg-transparent border-none w-full resize-none`}
        ></textarea>
        {error && (
          <span className="absolute bottom-2 left-7 text-red text-sm">
            {error}
          </span>
        )}
      </label>
    </>
  )
}

export default TextInputArea
